import Base from './components/cells/Base';
import Boolean from './components/cells/Boolean';

export default function BooleanCell() {}

BooleanCell.prototype.init = function (params) {
    this.eGui = Base(Boolean(params), params);
    return;
};

BooleanCell.prototype.getGui = function () {
    return this.eGui;
};
